import React from "react";
import { styleSetupConfig } from "../configs/style-config";
import { getImageUrl, updateState } from "../utils/function-utils";
import { InitialConfig } from "../models/common/common";
import { initConfig } from "../configs/initial-config";
import { initialStore } from "../stores/init_config_store";

//AVCDAMOSHI.002  25/03/2025  Add code for  Add initial config

export const useInitialCofig = (parameter? : { callback?: () => Promise<void> }) => {
    const [initialConfig, setInitialConfig] = React.useState<InitialConfig>(initConfig);
    const [loading, setLoading] = React.useState<boolean>(true);
    const logo = initialStore((state) => state.logo);

    React.useEffect(() => {
        executeAllSetUp();
        if (parameter && !!parameter.callback) parameter.callback();
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const executeAllSetUp = async (): Promise<void> => {
        await Promise.all(
            [setSetupStyleConfig(),setupWebdefaultConfig(), setClubCode()]
        )
    } 
    
    const setSetupStyleConfig = async (): Promise<void>  => {
        const stylesweb = window.sessionStorage.getItem('stylesetup');
        if (!stylesweb) {
            const initialStyles = styleSetupConfig();
            updateState<InitialConfig>({styles: initialStyles}, setInitialConfig);
            return;
        }else {
            const parseJson = JSON.parse(stylesweb);
            const addTypeStyle = styleSetupConfig(parseJson);
            updateState<InitialConfig>({styles: addTypeStyle}, setInitialConfig);
            return;
        }
    }

    const setupWebdefaultConfig = async (): Promise<void> => {
        const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
        try {
            if (!setupwebdefault) return;
            if (!logo || logo === "") {
                const setupweb = JSON.parse(setupwebdefault);
                const image = await getImageUrl(setupweb.club_logo_path);
                updateState<InitialConfig>({logo: image}, setInitialConfig);
            }else {
                updateState<InitialConfig>({logo: logo}, setInitialConfig);
            }
        } catch (error: any) {
            console.error(error);
            return;
        }   
    }

    const setClubCode = async (): Promise<void> => {
        const clubCode = window.sessionStorage.getItem("Club_Code");
        if (!clubCode) return;
        updateState<InitialConfig>({club_code: clubCode}, setInitialConfig);
    } 

    return { initialConfig, loading, setLoading }
}

//C-AVCDAMOSHI.002  25/03/2025  Add code for  Add initial config